import React from 'react';

import './AboutMeComponent.css';

class AboutMeComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="about" className='aboutmecomponent_wrapper'>
                <div className="tContainer">
                    <h2>Hi, ich bin Alex.</h2> 
                    <br />
                    <p>Als Webentwickler sehe ich das Internet vorrangig als Chance sich auf eine Art kreativ zu präsentieren und auszudrücken, die konventionellen Medien vorenthalten bleibt.</p>
                    <p>Ich bin stets an den neusten Technologien interessiert und teste gerne die Grenzen des möglichen.</p>
                </div>
            </div>
        );
    }
}

export default AboutMeComponent;


// WEBPACK FOOTER //
// ./src/AboutMeComponent/AboutMeComponent.react.js